// extracted by mini-css-extract-plugin
export default {"button":"XsellButton-button_Uur5F","default":"XsellButton-default_rmGtA"};